// extracted by mini-css-extract-plugin
module.exports = {"main":"SuccessMessage_main__RDklJ"};